import Vue from "vue";
import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

Vue.use(VueLoading);

const Plugin = {};

class GlobalSpinner {
  loader = null;
  loadingOverlay = null;

  constructor(loadingOverlay) {
    this.loadingOverlay = loadingOverlay;
  }

  show() {
    this.loader = this.loadingOverlay.show({
      color: 'blue',
      canCancel: false,
      loader: 'spinner',
    });
  }

  hide() {
    if (this.loader) {
      this.loader.hide();
    }
  }
}

Plugin.install = function (Vue) {
  Vue.prototype.$globalSpinner = new GlobalSpinner(Vue.prototype.$loading);
}

export default Plugin;
